
export function formatNumberString(input: any, decimalPlaces: number): string {
    const numberValue = parseFloat(input);
    if (!isNaN(numberValue)) {
        return numberValue.toFixed(decimalPlaces);
    } else {
        return input;
    }
}